<template>
    <v-container class="container">
        <hotel-form  :dialog-data.sync="responseDialog" :duplicated-dialog="duplicatedDialog" @finish="finish"/>
    </v-container>
</template>

<script>
import HotelForm from "../../components/Hotel/HotelForm.vue";

export default {
    name: "CreateHotel",
    components: {
        HotelForm,
    },
    data: () => ({
        responseDialog: {
            model: false,
            loading: false,
            dialogTitle: '',
            dialogMessage: '',
            dialogType: ''
        },
        duplicatedDialog: {
            model: false,
            hotels: []
        },
    }),
    methods: {
        finish: function (data) {
            if (!this.hasPermission) {
                this.$router.push('/');
                return;
            }
            this.responseDialog.loading = true;
            axios.post('/api/hotel/store', data)
                .then(res => {
                    if (res.data.success) {
                        if (res.data.hotel.is_cnpj_validated === false) {
                            this.responseDialog.dialogTitle = 'CNPJ Pendente';
                            this.responseDialog.dialogMessage = "O hotel foi cadastrado, mas o CNPJ ainda precisa ser validado." +
                                "\nVocê pode tentar validar novamente na aba 'Aprovação de Hotéis'.";
                            this.responseDialog.dialogType = 'warning';
                        } else {
                            this.responseDialog.dialogTitle = 'Sucesso!';
                            this.responseDialog.dialogMessage = 'Hotel cadastrado e CNPJ validado com sucesso.';
                            this.responseDialog.dialogType = 'success';
                        }
                        this.responseDialog.model = true;
                    } else {
                        throw res;
                    }
                })
                .catch(error => {
                    if (error.response?.data?.data?.duplicatedHotels) {
                        this.duplicatedDialog.model = true;
                        this.duplicatedDialog.hotels = error.response.data.data.duplicatedHotels;
                        return;
                    }
                    this.handleError(error.response);
                })
                .finally(() => {
                    this.responseDialog.loading = false;
                });
        },
        handleError: function (response) {
            let message = 'Erro inesperado. Tente novamente mais tarde.';

            if (typeof response?.data === "string") {
                message = response.data;
            } else if (response?.data?.message) {
                message = response.data.message;
                if (response?.data?.fields) {
                    const allErrors = Object.values(response.data.fields).flat();
                    message = allErrors.join('<br>');
                }
                else{
                    message = response.data.message;
                }

            } else if (response?.status) {
                message = `Erro ${response.status}: ${response.statusText}`;
            }

            console.error("Erro na validação do CNPJ:", response);

            this.responseDialog.dialogTitle = 'Erro ao validar CNPJ';
            this.responseDialog.dialogMessage = message;
            this.responseDialog.dialogType = 'error';
            this.responseDialog.model = true;
        }
    },
    computed: {
        hasPermission () {
            return this.$can('create.hotels');
        }
    }
}
</script>

<style lang="scss" scoped>
.container{
    width: 80%;
}

</style>
